import { createAction } from 'redux-actions';

export const setLinks = createAction('app/SET_MW_LINKS');

export const setLinksLength = createAction('app/SET_MW_LINKS_LENGTH');
